<template>
  <span v-if="!isReadOnly" class="dpwrapper">
    <hy-date :id="id" v-model="date" :placeholder="placeholder" type="datetime-local"/>
    <!-- <input :id="id"  v-model="date" :placeholder="placeholder"/> -->
  </span>
  <span v-else-if="dateString" >{{dateString}}</span>
  <span v-else>&ZeroWidthSpace;{{ nullDisplayValue }}</span> <!-- wenn attribute ungesetzt ist stelle Whitespace dar, damit regulärere Platz reserviert wird-->
  <!-- Datepicker? -->
  <!-- https://icehaunter.github.io/vue3-datepicker/ -->
  <!-- https://www.npmjs.com/package/vue3-datepicker-lite/v/1.9.1 -->
</template>

<script>
import {date2XMLRDB, datetime2german} from "../../utils/date"
import Attribute from "../../xmlrdb-data/Attribute"
import HyDate from "../../basic-components/HyDate.vue";
import { computed } from "vue"


function date2Datefield(date) {
  const d = date2XMLRDB(date);
  return d.substring(0,10);
}

export default {
  name: "dateField",
  props: {
    attribute: Attribute,
    isReadOnly: Boolean,
    placeholder: String,
    nullDisplayValue: { type: String, default: "" },
    id: String 
  },
  // clickableAttributeLabel: true, 
  clickableContainer: true,
  components: {
    HyDate
  },
  setup(props){

    const date = computed({
      set(newStringDate){
        // hat sich das Datum verändert?
        if(newStringDate){
          props.attribute.value = new Date(newStringDate);
        }
        else{
          props.attribute.value = null
        }
      },
      get(){
        if (props.attribute.value instanceof Date) {
          const timezoneOffsetmSec = props.attribute.value.getTimezoneOffset() * 1000 * 60;
          const d = new Date(props.attribute.value.getTime() - timezoneOffsetmSec).toISOString();
          return /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.exec(d)[0]; // nur den Date-Teil
        }
        return "";
      }
    });

    function getDateString(){
      const date = props.attribute.value;
      if( props.attribute.value && !Number.isNaN(date.getTime())){
        return datetime2german(date);
      }
      return props.placeholder;
    }

    return {
      dateString: computed(getDateString),
      date
    }
  }
}

</script>

<style scoped>

</style>